import "./Stages.scss";
import SectionTitle from "../../UI/SectionTitle/SectionTitle";
import CardSwap, { Card } from "../../UI/CardSwap/CardSwap";
import StagesCard from "../../UI/StagesCard/StagesCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { stagesCard, imageCards } from "./StagesData";


const Stages = () => {
  return (
    <section className="stages" id="stages">
      <div className="container">
        <div className="stages__wrapper">
          <SectionTitle
            title="Этапы работы"
            description="Так мы&nbsp;вместе движемся от&nbsp;идеи к&nbsp;готовому продукту"
            // icon="/"
          />

          <div className="stages__content">
            <ul className="stages__list">
              {stagesCard.map(({ key, title, list }, index) => (
                <li className="stages__item" key={key}>
                  <StagesCard title={title} list={list} number={++index} />
                </li>
              ))}
            </ul>

            <div className="stages__cardSwap">
              <CardSwap
                cardDistance={60}
                verticalDistance={70}
                delay={5000}
                pauseOnHover={false}
              >
                {imageCards.map(({ title, img, icon, imgWebp }) => (
                  <Card key={title} customClass="stages__card">
                    <h3 className="stages__card-title">
                      <span className="stages__card-circle stages__card-circle--red"></span>
                      <span className="stages__card-circle stages__card-circle--yellow"></span>
                      <span className="stages__card-circle stages__card-circle--green"></span>
                      <FontAwesomeIcon icon={icon} />
                      {title}
                      </h3>
                    <picture>
                      {imgWebp && <source srcSet={imgWebp} type="images/webp"></source>}
                      <img
                      className="stages__card-img"
                      src={img}
                      alt={title}
                      loading="lazy"
                    ></img>
                    </picture>
                  </Card>
                ))}
              </CardSwap>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stages;
